import api from './api';

export type YanxuanMonthlyTripartiteAgreementStatus = {
  slug: string;
  version: string;
  title: string;
  content: string;
  required: boolean;
  accepted: boolean;
  accepted_at: string | null;
  party_type: 'BUYER_ORG' | 'SUPPLIER' | null;
  party_id: number | null;
};

function unwrap<T>(response: any): T {
  return (response?.data?.data ?? response?.data) as T;
}

export async function fetchYanxuanMonthlyTripartiteAgreement() {
  return unwrap<YanxuanMonthlyTripartiteAgreementStatus>(
    await api.get('/yanxuan/agreements/monthly-tripartite'),
  );
}

export async function acceptYanxuanMonthlyTripartiteAgreement() {
  return unwrap<{
    party_type: string;
    party_id: number;
    agreement_slug: string;
    agreement_version: string;
    accepted_at: string;
  }>(await api.post('/yanxuan/agreements/monthly-tripartite/accept'));
}
